import { useState } from "react";
import { toast } from "sonner";
import { RotateCcw, Loader2 } from "lucide-react";
import { formatErr } from "../lib/api";

/**
 * „Ansicht zurücksetzen" — setzt serverseitige UI-Einstellungen (users.ui_prefs)
 * auf Standard. `onReset` führt den eigentlichen Reset aus (Kunde: Objekt-Auswahl,
 * Team: Sidebar + Kalender-Filter).
 */
export function ViewResetSection({ title, description, buttonLabel, onReset, testId = "view-reset" }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await onReset();
      toast.success("Ansicht auf Standard zurückgesetzt.");
    } catch (err) {
      toast.error(formatErr(err?.response?.data?.detail) || err.message || "Zurücksetzen fehlgeschlagen.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="bg-white border border-navy/10 p-6 md:p-8" data-testid={`${testId}-section`}>
      <div className="label-caps mb-2">Ansicht</div>
      <h3 className="text-navy text-lg mb-1">{title}</h3>
      <p className="text-[12.5px] text-navy-dark/60 mb-5 leading-relaxed max-w-2xl">{description}</p>
      <button
        type="button"
        onClick={run}
        disabled={busy}
        data-testid={`${testId}-btn`}
        className="inline-flex items-center gap-2 border border-navy/25 hover:border-gold hover:text-gold text-navy-dark px-4 py-2 text-[11px] tracking-[0.15em] uppercase transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
      >
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RotateCcw className="w-3.5 h-3.5" strokeWidth={1.6} />}
        {buttonLabel}
      </button>
    </section>
  );
}
